export function timestamp(value: string | null | undefined): string {
  return value == null
    ? "—"
    : new Date(value).toLocaleString(undefined, {
        timeZone: "America/New_York",
        timeZoneName: "short",
      });
}
export function money(value: number): string {
  return `$${value.toFixed(4)}`;
}
export function action(value: string | undefined): string {
  return value === "EXIT" ? "SELL / EXIT" : (value?.replaceAll("_", " ") ?? "—");
}
